import { createSelector } from 'reselect';
import { get } from 'lodash';

import { getCurrentLanguage } from 'modules/language/selectors/language';

const getOrganizationConfig = state => get(state, 'common.organizationConfig');

export const getCommonUserConfig = createSelector(
  [getOrganizationConfig, (state, userType) => userType],
  ({ generalConfig: { externalIdName = [], externalIdNamePlaceholder = [], userValidation }, defaultPhoneCountryCode }, userType = 'patient') => {
    if (!userValidation || !userType) return { requiredFields: [], loginFields: [] };
    const lang = getCurrentLanguage();

    return ({
      externalIdLabel: get(externalIdName.find(({ locale }) => locale.toLowerCase() === lang), 'value'),
      externalIdPlaceholder: get(externalIdNamePlaceholder.find(({ locale }) => locale.toLowerCase() === lang), 'value'),
      userPhoneCountryCode: defaultPhoneCountryCode,
      ...userValidation[userType.toLowerCase()],
    });
  },
);
